import {
  DataViewFilters,
  DataViewsPresenterModel,
  LiteDataModulePresenterModel,
  ServiceRequestSource,
} from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace ViewActions {
  /**
   *
   */
  export class TransitoryFetchViews {
    static readonly type = '[Views] TransitoryFetch Views';
    constructor(
      public payload: {
        /**
         * normalized entity name or entity id
         */
        entityId?: string;
        skip?: number;
        limit?: number;
        searchTerm?: string;
        moduleId?: string;
        filters?: DataViewFilters;
        viewId?: string;
        published?: boolean;
        includeImplicitViews?: boolean;
      },
    ) {}
  }

  export class FetchViewsForAdmin {
    static readonly type = '[Views] FetchViewsForAdmin Views';
    constructor(
      public payload: {
        /**
         * normalized entity name or entity id
         */
        skip?: number;
        limit?: number;
        searchTerm?: string;
        filters?: any;
        includeImplicitViews?: boolean;
      },
    ) {}
  }
  export class FetchViewsForAdminCount {
    static readonly type = '[Views] TransitoryFetch Views count';
    constructor(
      public payload: {
        /**
         * normalized entity name or entity id
         */
        filter?: { [key: string]: any };
        searchTerm?: string;

        includeImplicitViews?: boolean;
      },
    ) {}
  }

  export class FetchViews {
    static readonly type = '[Views] Fetch Views';
    constructor(
      public payload: {
        /**
         * normalized entity name or entity id
         */
        entityId: string;
        skip?: number;
        limit?: number;
        searchTerm?: string;
        filters?: { [key: string]: any };
        keepData?: boolean;
        includeImplicitViews?: boolean;
      },
    ) {}
  }

  export class SelectView {
    static readonly type = '[Views] Select View';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public viewId: string,
      public useExplicitAccessId?: boolean,
    ) {}
  }

  export class SetContextView {
    static readonly type = '[Views] Set Context View';
    constructor(
      public contextId: string,
      public entityId: string,
      public viewId: string,
    ) {}
  }

  export class SetContextViewForEndUser {
    static readonly type = '[Views] Set Context View For End-User';
    constructor(
      public contextId: string,
      public viewId: string,
    ) {}
  }

  export class FetchView {
    static readonly type = '[Views] Fetch View';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public viewId: string,
    ) {}
  }

  export class CreateView {
    static readonly type = '[Views] Create View';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public view: DataViewsPresenterModel,
      public moduleDetails: LiteDataModulePresenterModel,
    ) {}
  }

  export class UpdateView {
    static readonly type = '[Views] Update View';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public view: DataViewsPresenterModel,
      public moduleDetails: LiteDataModulePresenterModel,
    ) {}
  }

  export class FetchPublishedViews {
    static readonly type = '[Views] Fetch publish Views';
    constructor(
      public payload: {
        skip?: number;
        limit?: number;
        searchTerm?: string;
      },
    ) {}
  }
  export class DeleteView {
    static readonly type = '[Views] Delete View';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public viewId: string,
    ) {}
  }
  export class FetchDefaultView {
    static readonly type = '[Views] Fetch Default View';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
    ) {}
  }

  export class GetCountsByTypes {
    static readonly type = '[Views] get counts by permission scoop';
    constructor(
      public payload: {
        entityId: string;
        searchTerm?: string;
        filter?: { [key: string]: any };
      },
    ) {}
  }

  export class FetchViewForEndUser {
    static readonly type = '[Views] Fetch Views for end users';
    constructor(
      public payload: {
        viewId: string;
        /** In some cases we need to provide the viewId as accessId explicitly, if the public accessId is not ready yet (such as in Guards) */
        useExplicitAccessId?: boolean;
      },
    ) {}
  }

  export class FetchViewPermissionsForEndUser {
    static readonly type = '[Views] Fetch View permissions for end users';
    constructor(
      public payload: {
        viewId: string;
      },
    ) {}
  }

  export class FetchAnonymousView {
    static readonly type = '[Views] Fetch Anonymous View by token';
    constructor(public payload: { token: string }) {}
  }

  export class FetchServiceImplicitViewForRequest {
    static readonly type = '[Views] Can Access Service Request';
    constructor(
      public entityId: string,
      public source: ServiceRequestSource,
      public requestId?: string,
      public isDraft?: boolean,
    ) {}
  }

  export class FetchViewByRelation {
    static readonly type = '[Views] Fetch View by Relation';
    constructor(
      public entityId: string,
      public viewId: string,
      public relationId: string,
      public relatedEntryId?: string,
      public mainViewId?: string,
    ) {}
  }
}
